import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreferencesService } from './preferences.service';
import { PreferencesLogicService } from './logic/preferences/preferences-logic.service';
@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [
        {
            provide: PreferencesService,
            useClass: PreferencesLogicService
        }
    ]
})
export class PreferencesModule { }